export default __webpack_public_path__ + "static/media/StockSnap_95PRN3JH49.772734a6.png";